exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Title-module__wrapper___1Z5lE{display:grid;margin-bottom:1rem;align-items:center;gap:1rem}@media screen and (min-width:525px){.Title-module__wrapper___1Z5lE{grid-template-columns:1fr auto}}.Title-module__container___20y16{display:grid;grid-auto-flow:column;justify-content:start;gap:.5rem}.Title-module__container___20y16 .Title-module__loader-wrapper___1BIEL{align-self:center}.Title-module__container___20y16 .Title-module__loader-wrapper___1BIEL svg{font-size:22px;color:#0827e9}", ""]);

// exports
exports.locals = {
	"wrapper": "Title-module__wrapper___1Z5lE",
	"container": "Title-module__container___20y16",
	"loader-wrapper": "Title-module__loader-wrapper___1BIEL"
};